import { axiosInstance } from "../../../axios/axiosInstance";

const API_PACKAGES_URL = "organization/packages/";
const API_PACKAGES_MODULE_LIST_URL =
  API_PACKAGES_URL + "get-all-provider-packages";
const API_CREATE_PACKAGE_MODULE_URL = API_PACKAGES_URL + "add-package";
const API_UPDATE_PACKAGE_MODULE_URL = API_PACKAGES_URL + "update-package";
const API_GET_PACKAGE_MODULE_BY_ID_URL = API_PACKAGES_URL + "get-package-by-id";
const API_DELETE_PACKAGE_MODULE_URL = API_PACKAGES_URL + "delete-package";

export const getPackages = (dataToBeSent) => {
  return axiosInstance.get(`${API_PACKAGES_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const createPackage = (dataToBeSent) => {
  return axiosInstance.post(API_CREATE_PACKAGE_MODULE_URL, dataToBeSent);
};

export const updatePackage = (dataToBeSent) => {
  return axiosInstance.patch(
    API_UPDATE_PACKAGE_MODULE_URL + "/" + dataToBeSent?._id,
    dataToBeSent
  );
};

export const getPackageById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_PACKAGE_MODULE_BY_ID_URL + "/" + dataToBeSent?.selectedPackageId
  );
};

export const deletePackageById = (dataToBeSent) => {
  return axiosInstance.delete(
    API_DELETE_PACKAGE_MODULE_URL + "/" + dataToBeSent?.selectedPackageId
  );
};
